export default class Counter {
  count: number;

  constructor() {
    this.count = 0;
  }

  /**
   * Increment the current count value.
   */
  increment(): void {
    this.count += 1;
  }

  /**
   * Read the current count and return it.
   *
   * @returns - current count value.
   */
  get(): number {
    return this.count;
  }

  /**
   * Read the current count value. After read, increment the counter. Return the current (read) value.
   *
   * @returns - current count value.
   */
  getAndIncrement(): number {
    const current = this.get();
    this.increment();
    return current;
  }
}
